import React, { useState } from "react";

import { FaUtensils } from "react-icons/fa";
import { svg } from "../assets/svg";
import { hooks } from "../hooks";
import { DishType } from "../types";
import { getItemFromLocalStorage } from "../utils/getItemFromLocalStorage";

type Props = {
  dish: DishType;
  isLast: boolean;
  fromAI?: boolean|false;
  dishReason?:String;
};

export const MenuListItem: React.FC<Props> = ({ dish, isLast,fromAI,dishReason }) => {
  const navigate = hooks.useNavigate();
  
  const MENU_CONFIG=getItemFromLocalStorage("menuConfiguration")
 
  const { addToCart, getDishQty ,removeFromCart} = hooks.useCartHandler();
  const { ifInWishlist, addToWishlist, removeFromWishlist } =
    hooks.useWishlistHandler();

  const [isFullPrice, setIsFullPrice] = useState(true);
  const qty = getDishQty(dish.id ?? 0, isFullPrice);

  const togglePrice = () => {
    setIsFullPrice((prev) => !prev);
  };
  return (
   <>
    <li
      style={{
        borderRadius: fromAI ? "16px 16px 0 0" : 16,
        padding: "16px",
        backgroundColor: "var(--white-color)",
        marginBottom: isLast ? 0 : 12,
        position: "relative",
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        border: '1px solid rgba(0, 0, 0, 0.04)',
        cursor: dish.availability ? 'pointer' : 'not-allowed',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      onClick={() =>
        dish.availability
          ? navigate(`/dish/${dish.id}`, { state: { dish } })
          : null
      }
      onMouseEnter={(e) => {
        if (dish.availability) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.06)';
      }}
    >
      {/* Image Container */}
      <div style={{
        position: 'relative',
        flexShrink: 0,
      }}>
        {dish.image ? (
          <img
            src={dish.image}
            alt={dish.name}
            style={{
              width: 100,
              height: 100,
              borderRadius: 12,
              objectFit: "cover",
              display: 'block',
            }}
          />
        ) : (
          <div
            style={{
              width: 100,
              height: 100,
              borderRadius: 12,
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e7eb 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaUtensils
              style={{
                color: "#b0b8c1",
                fontSize: "28px",
                opacity: 0.8,
              }}
            />
          </div>
        )}
        
        {/* Veg/Non-Veg Badge - Professional Food Labeling */}
        {dish.availability && (
          <div
            style={{
              position: 'absolute',
              top: 10,
              left: 10,
              width: 28,
              height: 28,
              padding: '3px',
              backgroundColor: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '3px',
              border: '1.5px solid rgba(0, 0, 0, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              zIndex: 2,
            }}
          >
            {dish.category === "Veg" ? (
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#ffffff',
                borderRadius: '2px',
                border: '2px solid #2ecc71',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <div style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: '#2ecc71',
                  border: '1.5px solid #2ecc71',
                }} />
              </div>
            ) : (
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#ffffff',
                borderRadius: '2px',
                border: '2px solid #e74c3c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <div style={{
                  width: 0,
                  height: 0,
                  borderLeft: '4px solid transparent',
                  borderRight: '4px solid transparent',
                  borderTop: '7px solid #e74c3c',
                  borderBottom: 'none',
                }} />
              </div>
            )}
          </div>
        )}
      </div>
    
      {/* Full/Half Toggle */}
      {dish.availability && (dish.halfPrice !== 0) && (
        <div
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(8px)',
            borderRadius: 20,
            padding: '4px 8px',
            fontSize: 11,
            fontWeight: 600,
            color: '#333',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            zIndex: 2,
            transition: 'all 0.2s ease',
          }}
          onClick={(e) => {
            e.stopPropagation();
            togglePrice();
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.12)';
          }}
        >
          <span
            style={{
              fontSize: 10,
              fontWeight: !isFullPrice ? 700 : 500,
              color: !isFullPrice ? 'var(--main-turquoise)' : '#666',
            }}
          >
            Half
          </span>
          <div
            style={{
              width: 30,
              height: 16,
              borderRadius: 20,
              background: isFullPrice ? 'var(--main-turquoise)' : '#ddd',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: isFullPrice ? 'flex-end' : 'flex-start',
              padding: '2px',
              cursor: 'pointer',
              transition: 'background 0.3s ease',
            }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                background: 'white',
                transition: 'transform 0.3s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              }}
            />
          </div>
          <span
            style={{
              fontSize: 10,
              fontWeight: isFullPrice ? 700 : 500,
              color: isFullPrice ? 'var(--main-turquoise)' : '#666',
            }}
          >
            Full
          </span>
        </div>
      )}
      
      {/* Unavailable Overlay */}
      {!dish.availability && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.65)",
            backdropFilter: 'blur(2px)',
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: 600,
            textAlign: "center",
            borderRadius: 16,
            zIndex: 3,
            fontFamily: 'DM Sans, sans-serif',
          }}
        >
          Not Available
        </div>
      )}

      {/* {dish.isChefSpecial&&dish.availability && (
        <img
          alt='New'
          src={require('../assets/icons/14.png')}
          style={{
            width: 34,
            height: 'auto',
            margin: 14,
            left: 0,
            top: 0,
            position: 'absolute',
          }}
        />
      )} */}
      {/* Content Section */}
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        flex: 1,
        minWidth: 0,
      }}>
        <h4
          style={{
            marginBottom: 6,
            marginTop: 0,
            display: "block",
            color: "var(--main-color)",
            textTransform: "capitalize",
            fontSize: 16,
            fontWeight: 700,
            fontFamily: 'DM Sans, sans-serif',
            lineHeight: 1.3,
            letterSpacing: '-0.3px',
          }}
          className="number-of-lines-2"
        >
          {dish.name}
        </h4>
        
        {MENU_CONFIG?.isInfoSupported && dish.description && (
          <p
            className="number-of-lines-2"
            style={{
              fontSize: 12,
              color: "var(--text-color)",
              lineHeight: 1.5,
              marginBottom: 6,
              marginTop: 0,
              fontFamily: 'DM Sans, sans-serif',
            }}
          >
            {dish.description}
          </p>
        )}
        
        {MENU_CONFIG?.isInfoSupported && dish.kcal && (
          <span 
            style={{ 
              marginBottom: 10,
              fontSize: 11,
              color: 'var(--text-color)',
              fontFamily: 'DM Sans, sans-serif',
              opacity: 0.8,
            }}
          >
            {dish.kcal} kcal
          </span>
        )}
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: 'auto',
        }}>
          <span
            style={{
              color: "var(--main-turquoise)",
              fontSize: 18,
              fontWeight: 700,
              fontFamily: 'DM Sans, sans-serif',
            }}
          >
            ₹{isFullPrice ? dish.price : dish.halfPrice}
          </span>
        </div>
      </div>
      {/* Action Buttons */}
      {dish.availability && (
        <div style={{
          position: "absolute",
          right: 12,
          bottom: 12,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          alignItems: 'flex-end',
        }}>
          {/* Wishlist Button */}
          {MENU_CONFIG?.isOrderFromAppSupported && (
            <button
              style={{
                width: 36,
                height: 36,
                padding: 0,
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(8px)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                transition: 'all 0.2s ease',
                zIndex: 2,
              }}
              onClick={(event) => {
                event.stopPropagation();
                ifInWishlist(dish.id ?? 0)
                  ? removeFromWishlist(dish, event)
                  : addToWishlist(dish, event);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.18)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.12)';
              }}
            >
              <svg.HeartSvg dish={dish} />
            </button>
          )}
          
          {/* Add to Cart Controls */}
          {MENU_CONFIG?.isAddtoCartEnabled && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}>
              {qty > 0 && (
                <button
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    backgroundColor: 'var(--main-turquoise)',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 8px rgba(0, 176, 185, 0.35)',
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    removeFromCart(dish, event);
                  }}
                  disabled={!dish.availability}
                  aria-label="Remove from cart"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = '#00a0a8';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 176, 185, 0.45)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = 'var(--main-turquoise)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 176, 185, 0.35)';
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={16}
                    height={16}
                    fill='none'
                    style={{ display: 'block' }}
                  >
                    <path
                      stroke='#ffffff'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M2.898 8h10.204'
                    />
                  </svg>
                </button>
              )}

              {qty > 0 && (
                <span style={{
                  fontFamily: 'DM Sans, sans-serif',
                  fontWeight: 700,
                  fontSize: 16,
                  color: 'var(--main-color)',
                  minWidth: 24,
                  textAlign: 'center',
                }}>
                  {qty}
                </span>
              )}

              <button
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  backgroundColor: 'var(--main-turquoise)',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 8px rgba(0, 176, 185, 0.35)',
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  addToCart({ ...dish, isFullPrice }, event);
                }}
                disabled={!dish.availability}
                aria-label="Add to cart"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.backgroundColor = '#00a0a8';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 176, 185, 0.45)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = 'var(--main-turquoise)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 176, 185, 0.35)';
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={16}
                  height={16}
                  fill='none'
                  style={{ display: 'block' }}
                >
                  <path
                    stroke='#ffffff'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M8 3.5v9M3.5 8h9'
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      )}
      
    </li>
    {fromAI&&<div style={{
        borderRadius: "0 0 10px 10px", // Only bottom left & right
        padding: "14px 14px",
        backgroundColor: "var(--white-color)",
        marginBottom: isLast ? 0 : 10,
        position: "relative",
      }}>
                <h2 className="text-base font-semibold text-gray-800 mb-1">
                  Why this dish?
                </h2>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {dishReason}
                </p>
              </div>}
    </>
  );
};
